import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ErrorBoundary, installFrontendErrorReporting } from "./components/ErrorBoundary";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import ShopHome from "./pages/ShopHome";
import RootGate from "./pages/RootGate";
import Diary from "./pages/Diary";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Services from "./pages/Services";
import Barbers from "./pages/Barbers";
import ShopProfile from "./pages/ShopProfile";
import Analytics from "./pages/Analytics";
import Billing from "./pages/Billing";
import Templates from "./pages/Templates";
import ChangePassword from "./pages/ChangePassword";
import Account from "./pages/Account";
import BarberSchedule from "./pages/BarberSchedule";
import Booking from "./pages/Booking";
import CancelBooking from "./pages/CancelBooking";
import PayDeposit from "./pages/PayDeposit";
import ShopShortRedirect from "./pages/ShopShortRedirect";
import StripeSetup from "./pages/StripeSetup";
import Welcome from "./pages/Welcome";
import AdminShops from "./pages/admin/Shops";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminOnboarding from "./pages/admin/Onboarding";
import AdminOnboardShop from "./pages/admin/OnboardShop";
import AdminShopDetail from "./pages/admin/ShopDetail";
import AdminBilling from "./pages/admin/AdminBilling";
import AdminRevenue from "./pages/admin/Revenue";
import AdminChurn from "./pages/admin/Churn";
import AdminSettings from "./pages/admin/PlatformSettings";
import NotFound from "./pages/NotFound";
import AdminIntegrations from "./pages/admin/Integrations";
import AdminDomainReadiness from "./pages/admin/DomainReadiness";
import BookingIntel from "./pages/admin/BookingIntel";
import SystemHealth from "./pages/admin/SystemHealth";
import AdminPlatformTemplates from "./pages/admin/PlatformTemplates";

function App() {
  useEffect(() => { installFrontendErrorReporting(); }, []);
  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootGate />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/diary" element={<Diary />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/:id" element={<ClientDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/barbers" element={<Barbers />} />
          <Route path="/profile" element={<ShopProfile />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/account" element={<Account />} />
          <Route path="/settings/schedule" element={<BarberSchedule />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/shop/:subdomain" element={<ShopHome />} />
          <Route path="/book/:subdomain" element={<Booking />} />
          <Route path="/cancel/:token" element={<CancelBooking />} />
          <Route path="/c/:token" element={<CancelBooking />} />
          <Route path="/pay/:token" element={<PayDeposit />} />
          <Route path="/s/:code" element={<ShopShortRedirect />} />
          <Route path="/stripe-setup" element={<StripeSetup />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/shops" element={<AdminShops />} />
          <Route path="/admin/shops/:id" element={<AdminShopDetail />} />
          <Route path="/admin/onboarding" element={<AdminOnboarding />} />
          <Route path="/admin/onboard" element={<AdminOnboardShop />} />
          <Route path="/admin/billing" element={<AdminBilling />} />
          <Route path="/admin/revenue" element={<AdminRevenue />} />
          <Route path="/admin/churn" element={<AdminChurn />} />
          <Route path="/admin/integrations" element={<AdminIntegrations />} />
          <Route path="/admin/domain-readiness" element={<AdminDomainReadiness />} />
          <Route path="/admin/booking-intel" element={<BookingIntel />} />
          <Route path="/admin/system-health" element={<SystemHealth />} />
          <Route path="/admin/message-templates" element={<AdminPlatformTemplates />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
